import SalePlanHomeDiagram from "../../components/statistics/planHomeDiagram";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "sonner";
import PanelSearch from "../../components/filters/panelSearch";
import { FilterIcon } from "../../icons/filter";
import UserListTable from "../../components/users/userListTable";
import { actions, RootState } from "../../state/reducer";
import { closeModal, openModal } from "../../state/modalSlice";
import UserFilterModal from "../../modals/filters/user";
import { UserFilters } from "../../forms/filters/user";
import { UserShortInfo } from "types";
import PanelPage from "../../components/panel/panelPage";

const SalesPlanPage = () => {
  const [searchValue, setSearchValue] = useState("");
  const [selectedUser, setSelectedUser] = useState<UserShortInfo>();
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();


  const search = (value: string) => {
    setSearchValue(value);
  };

  const handleOpenFilters = () => {
    dispatch(
      openModal({
        component: UserFilterModal,
        context: {
          onApplyFilters: (filters: UserFilters) => {
            setSearchValue("");
            dispatch(actions.userRequestParams(filters));
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  return (
    <PanelPage>
        <div className="panelColumnFull">
          <div className="flex between w100 panelColumnFull">
            <div className="columnCenter panelColumnFull">
              <SalePlanHomeDiagram userId={selectedUser?.id} enableSettings={true} userInfo={selectedUser} />
              <div className="panel eventListPanel">
                <div className="flex between panelSearchContainer">
                  <PanelSearch hint={"Поиск по ФИО"} onChange={search} />
                  <div className="btn filterBtn" onClick={handleOpenFilters}>
                    <FilterIcon width={20} height={20} />
                  </div>
                </div>
                <UserListTable search={searchValue} onUserClickCallback={
                  (user) =>{ 
                    console.log("Selected:", user)
                    setSelectedUser(user)
                  }
                  }/>
              </div>
            </div>
          </div>
        </div>
      </PanelPage>
  );
};

export default SalesPlanPage;
